<template>
  <div v-if="content" class="illustration">
    <h1 v-html="content.title"></h1>
    <div id="parallax-container">
      <div class="parallax-item" style="background-image: url(/img/parallax/plan7.png);"></div>
      <div class="parallax-item" style="background-image: url(/img/parallax/plan6.png);"></div>
      <div class="parallax-item" style="background-image: url(/img/parallax/plan5.png);"></div>
      <div class="parallax-item" style="background-image: url(/img/parallax/plan4.png);"></div>
      <div class="parallax-item" style="background-image: url(/img/parallax/plan3.png);"></div>
      <div class="parallax-item" style="background-image: url(/img/parallax/plan2.png);"></div>
      <div class="layer" style="background-image: url(/img/parallax/plan1.png);"></div>
      <!-- <div class="layer" style="background: url(/img/parallax/plen1.png);"></div> -->
    </div>
    <scroll-indicator></scroll-indicator>
    <!--<svg class="wave" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1170 193">
      <path d="M1175 131.2c0 0-81-89.4-224.3-103.4S713 72 665 97c-86 46-148 63-271 7C221.7 25.5 56 104.5-4 197.4 -4 58.7-3.3 0.3-3.3 0.3L1175 0V131.2z"></path>
    </svg>-->
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  methods: {
    parallax() {
      let parent = document.getElementById("parallax-container");
      let children = parent.getElementsByClassName("parallax-item");
      for (let i = 0; i < children.length; i++) {
        children[i].style.transform =
          "translateY(-" + (window.pageYOffset * i) / children.length + "px)";
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.parallax, false);
  },
  destroyed() {
    window.removeEventListener("scroll", this.parallax, false);
  }
};
</script>

<style lang="scss">
#parallax-container {
  height: 100vh;
  width: 100%;
  div {
    position: fixed;
    top: 0;
    background-position: center;
    transform: translateY(0px);
    height: 130vh;
    background-size: cover;
    width: 100%;
    bottom: 0;
    &.layer {
      background-position: bottom;
      position: absolute;
    }
  }
}

.illustration {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  clip-path: ellipse(100% 66% at 50% 34%);
  h1 {
    color: #fff;
    font-family: Luckiest Guy, cursive;
    font-size: 55px;
    text-shadow: -1px -1px 0 rgba(0, 0, 0, 0.8),
      -2px -2px 1px rgba(0, 0, 0, 0.8);
    position: absolute;
    z-index: 33;
    top: calc(50% - 15vh);
  }
}

@media screen and (max-width: 980px) {
  .illustration {
    clip-path: none;
    h1 {
      text-align: center;
    }
  }
}
</style>
